import {
  IsEnum,
  IsInt,
  IsISO8601, IsOptional,
  Matches
} from 'class-validator';
import { CountTimes } from '../../enum/cash-count/count-times.enum';

export class BankingMerchantLastCountsSearchRequestDto {
  @IsInt()
  costCentreId: number;

  @IsInt()
  currencyId: number;

  /**
   * countTime is required for selecting `float` cash count.
   */
  @IsOptional()
  @IsEnum(CountTimes, {
    message: `countTime must be a valid enum value: ${Object.values(CountTimes).join(', ')}`
  })
  countTime: CountTimes;

  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/, {
    message: 'day must be of format: YYYY-MM-DD'
  })
  day: string;
}
